import { Stacked } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';

export const SettingsPanel = ({ children }: { children: ReactNode }) => (
  <Stacked direction="column" gap="medium">
    {children}
  </Stacked>
);
